module.exports = __webpack_public_path__ + "img/icon-admin-yellow.99ca51c3.svg";